import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

/**
 * Kartochka — panelning asosiy sirti.
 *
 * Soya `--shadow-1` dan olinadi, Tailwind ning `shadow-sm` idan emas: qorong'i mavzuda soya
 * ko'rinmaydi (qora ustidagi qora), shu sababdan o'sha nom `.dark` da chuqurroq qiymatga
 * ega. Bitta nom, ikkita mavzu — komponent farqni bilmaydi.
 */
function Card({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="card"
      className={cn(
        'bg-card text-card-foreground border-border/70 flex flex-col gap-6 rounded-xl border py-6 shadow-(--shadow-1) transition-shadow duration-(--dur-control)',
        className,
      )}
      {...props}
    />
  );
}

function CardHeader({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-header"
      className={cn(
        '@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6',
        className,
      )}
      {...props}
    />
  );
}

/**
 * shadcn ning o'zida `CardTitle` — `div`.
 *
 * Bu yerda u ATAYLAB haqiqiy sarlavha: admin panelning har bir ekrani bir nechta jadvaldan
 * iborat, va klaviatura bilan ishlaydigan operator uchun sarlavhalar ro'yxati — sahifa bo'ylab
 * yurishning yagona tez yo'li. `as` orqali daraja tanlanadi.
 */
function CardTitle({
  className,
  as: Comp = 'h2',
  ...props
}: ComponentProps<'h2'> & { as?: 'h1' | 'h2' | 'h3' }) {
  return (
    <Comp
      data-slot="card-title"
      className={cn('text-base leading-none font-semibold tracking-tight', className)}
      {...props}
    />
  );
}

function CardDescription({ className, ...props }: ComponentProps<'p'>) {
  return (
    <p
      data-slot="card-description"
      className={cn('text-muted-foreground text-sm', className)}
      {...props}
    />
  );
}

function CardAction({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-action"
      className={cn('col-start-2 row-span-2 row-start-1 self-start justify-self-end', className)}
      {...props}
    />
  );
}

function CardContent({ className, ...props }: ComponentProps<'div'>) {
  return <div data-slot="card-content" className={cn('px-6', className)} {...props} />;
}

function CardFooter({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-footer"
      className={cn('flex items-center px-6 [.border-t]:pt-6', className)}
      {...props}
    />
  );
}

export { Card, CardHeader, CardFooter, CardTitle, CardAction, CardDescription, CardContent };
